/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindOperationChainItemsQueryResponse,
  FindOperationChainItemsPathParams,
} from "../types/FindOperationChainItems.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findOperationChainItemsQueryKey = (
  operationChainId: FindOperationChainItemsPathParams["operationChainId"]
) =>
  [
    {
      url: "/v1/operation-chain/find-operation-chain-items/:operationChainId",
      params: { operationChainId: operationChainId },
    },
  ] as const

export type FindOperationChainItemsQueryKey = ReturnType<
  typeof findOperationChainItemsQueryKey
>

/**
 * @summary Find operation chain items
 * {@link /v1/operation-chain/find-operation-chain-items/:operationChainId}
 */
export async function findOperationChainItems(
  operationChainId: FindOperationChainItemsPathParams["operationChainId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindOperationChainItemsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/operation-chain/find-operation-chain-items/${operationChainId}`,
    ...requestConfig,
  })
  return res
}

export function findOperationChainItemsQueryOptions(
  operationChainId: FindOperationChainItemsPathParams["operationChainId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findOperationChainItemsQueryKey(operationChainId)
  return queryOptions<
    ResponseConfig<FindOperationChainItemsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindOperationChainItemsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!operationChainId,
    queryKey,
    queryFn: async ({ signal }) => {
      return findOperationChainItems(operationChainId, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find operation chain items
 * {@link /v1/operation-chain/find-operation-chain-items/:operationChainId}
 */
export function useFindOperationChainItems<
  TData = ResponseConfig<FindOperationChainItemsQueryResponse>,
  TQueryData = ResponseConfig<FindOperationChainItemsQueryResponse>,
  TQueryKey extends QueryKey = FindOperationChainItemsQueryKey,
>(
  operationChainId: FindOperationChainItemsPathParams["operationChainId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindOperationChainItemsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    findOperationChainItemsQueryKey(operationChainId)

  const query = useQuery(
    {
      ...findOperationChainItemsQueryOptions(operationChainId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
